import { MaterialPreperationStatus } from "@gtpl/shared-models/common-models";
import {Column,Entity,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('prepared_stock')
export class PreapredStock {

  @PrimaryGeneratedColumn("increment",{name:'prepared_stock_id'})
  preparedStockId:number;


    @Column("int", {
        nullable: false,
        name: "sale_order_id"
      })
      saleOrderId: number;
      @Column("int", {
        nullable: false,
        name: "sale_order_item_id"
      })
      saleOrderItemId: number;
      @Column("int", {
        nullable: false,
        name: "item_id"
      })
      itemId: number;
      @Column("int", {
        nullable: true,
        name: "stock_id"
      })
      stockId: number;
      @Column("varchar", {
        nullable: false,
        name: "item_barcode",
        length:155,
      })
      itemBarcode: string;
      @Column("int",{
        nullable:true,
        // default:0,
        name:"prepared_quantity"
        })
        preparedQuantity:number;

        @Column("int",{
          nullable:true,
          default:0,
          name:"transfered_quantity"
          })
          transferedQuantity:number;
        @Column({
          type: 'enum',
          enum: MaterialPreperationStatus,
          nullable: false,
          name: 'status',
          default:MaterialPreperationStatus.PREPARED,
      })
      status: MaterialPreperationStatus;
    @Column("int",{
        nullable:true,
        default:0,
        name:"consumed_quantity"
        })
    consumedQuantity:number;
    @Column("int",{
        nullable:true,
        default:0,
        name:"stock_in_quantity"
        })
        stockInQuantity:number;

        @Column("int", {
          nullable: false,
          name: "unit_id"
      })
      unitId: number;
      @Column("varchar", {
        nullable: true,
        name: "barcode",
        length:155,
      })
      barcode: string;
      @Column("varchar", {
        nullable: true,
        name: "product_name",
        length:155,
      })
      productName: string;
      @Column("int", {
        nullable: true,
        name: "store_issue_id"
      })
      storeIssueId: number;
    @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50,
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
}
